import { useMutation } from '@tanstack/react-query'

import { queryClient } from '@sparkai/utils'

import { apiClient } from '../apiClient'
import { QUERY_KEY } from '../engagement/getByIdV3'

export type VoidQualityMetricsRequest = {
  removeGroundTruth: true
}

export type AuditVoidRequestAcceptedResponse = {
  status: 'accepted'
  auditVoidRequestId: string
  initiatingEngagementId: string
  liveEngagementId: string | null
  scope: 'related_engagements' | 'engagement'
}

export function useVoidEngagementQualityMetrics(engagementId: string) {
  return useMutation({
    mutationFn: async (payload: VoidQualityMetricsRequest) => {
      const { data, status } = await apiClient.post<AuditVoidRequestAcceptedResponse>(
        `/int/v3/engagements/audit/${engagementId}/void-quality-metrics`,
        payload
      )

      return { data, status }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY, engagementId],
      })
    },
  })
}

export function useVoidTaskQualityMetrics(engagementId: string, taskId: string) {
  return useMutation({
    mutationFn: async () => {
      if (!engagementId || !taskId) {
        throw new Error('Missing engagementId or taskId')
      }
      const { data, status } = await apiClient.post(`/int/v3/tasks/${taskId}/void-quality-metrics`)

      return { data, status }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY, engagementId],
      })
    },
  })
}
